var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25004 0.750013L5.25004 9.12751L1.59004 5.46751C1.29754 5.17501 0.817539 5.17501 0.525039 5.46751C0.232539 5.76001 0.232539 6.23251 0.525039 6.52501L5.46754 11.4675C5.76004 11.76 6.23254 11.76 6.52504 11.4675L11.4675 6.52501C11.76 6.23251 11.76 5.76001 11.4675 5.46751C11.175 5.17501 10.7025 5.17501 10.41 5.46751L6.75004 9.12751L6.75004 0.750013C6.75004 0.337513 6.41254 1.33514e-05 6.00004 1.33514e-05C5.58754 1.33514e-05 5.25004 0.337513 5.25004 0.750013Z",
    fill: "#CF0505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownBig);
export default __webpack_public_path__ + "static/media/down-big.ab1bdd85c726e953566c5b66f1e17bab.svg";
export { ForwardRef as ReactComponent };